import React from 'react'
import { Link, graphql } from 'gatsby'
import PropTypes from 'prop-types'
import { TabNav, TabLink } from './TabNavigation.style'

const isActive = ({ isPartiallyCurrent }) => {
  return isPartiallyCurrent ? {
    className: 'active',
  } : null
}

const TabNavigation = ({ pageLinks }) => (
  <TabNav>
    {pageLinks.map(link => (
      <TabLink key={link.id}>
        <Link to={link.slug} getProps={isActive}>{link.title}</Link>
      </TabLink>
    ))}
  </TabNav>
)

TabNavigation.propTypes = {
  pageLinks: PropTypes.arrayOf(PropTypes.shape({
    slug: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
  })).isRequired,
}

export default TabNavigation

export const TabNavigationFragment = graphql`
  fragment TabNavigationFragment on ContentfulTabNavigation {
    id
    pageLinks {
      slug
      title
    }
  }
`
